import { render, staticRenderFns } from "./properties_detail.vue?vue&type=template&id=17562088&scoped=true"
import script from "./properties_detail.vue?vue&type=script&lang=js"
export * from "./properties_detail.vue?vue&type=script&lang=js"
import style0 from "./properties_detail.vue?vue&type=style&index=0&id=17562088&prod&lang=css&scoped=true"
import style1 from "./properties_detail.vue?vue&type=style&index=1&id=17562088&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17562088",
  null
  
)

export default component.exports